/* global window */
const APP_ENV_SETTINGS =
  typeof window !== 'undefined' ? window.APP_ENV_SETTINGS : {};
const NODE_ENV_SETTINGS = typeof process !== 'undefined' ? process.env : {};
const STORE = {
  ...NODE_ENV_SETTINGS,
  ...APP_ENV_SETTINGS,
};
const DEPLOYMENT_ENVIRONMENT = STORE.DEPLOYMENT_ENVIRONMENT || 'development';
const IS_DEV = STORE.NODE_ENV !== 'production';
const NODE_ENV = STORE.NODE_ENV || 'development';
const FEATURE_MAGENTO2 = ['true', true].includes(STORE.FEATURE_MAGENTO2);
const APP_PORT = STORE.APP_PORT || 3000;
const APP_BASE_URL = STORE.APP_BASE_URL || 'http://www.test.ni.de';
const MAGENTO_URL = STORE.MAGENTO_URL || 'http://shop.test.ni.de';
const TYPO3_URL = STORE.TYPO3_URL || 'http://www.test.ni.de';
const ASSETS_PATH = STORE.ASSETS_PATH || '/assets/';
const { APP_VERSION } = STORE;

const FEATURE_TOKEN_COOKIE = 'FEATURE_TOKEN';
const FEATURE_TOKEN_HEADER = 'x-feature-token';
const APP_LANGUAGES = ['en', 'de', 'fr', 'es', 'jp', 'zh'];
const DEFAULT_LOCALE = 'en';
const APP_LANGUAGES_LABELS = {
  en: 'English',
  de: 'Deutsch',
  fr: 'Français',
  es: 'Español',
  jp: '日本語',
  zh: '简体中文',
};

/*
 * shared between webpack config and and our app template
 * make sure the package exists in webpack/cdn.json
 */
const CDN_EXTERNALS = [
  'react',
  'react-dom',
  'redux',
  'react-router-dom',
  'react-redux',
  '@sentry/browser',
];

module.exports = {
  APP_BASE_URL,
  APP_LANGUAGES,
  APP_LANGUAGES_LABELS,
  DEFAULT_LOCALE,
  APP_PORT,
  ASSETS_PATH,
  CDN_EXTERNALS,
  DEPLOYMENT_ENVIRONMENT,
  FEATURE_TOKEN_COOKIE,
  FEATURE_TOKEN_HEADER,
  IS_DEV,
  MAGENTO_URL,
  NODE_ENV,
  STORE,
  TYPO3_URL,
  APP_VERSION,
  FEATURE_MAGENTO2,
};
